export function computeTotal(data) {
  return data.reduce((sum, item) => sum + item.count, 0);
}
